import { render, staticRenderFns } from "./app-icon-btn.vue?vue&type=template&id=4d070ce8&lang=pug"
import script from "./app-icon-btn.vue?vue&type=script&lang=js"
export * from "./app-icon-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports